export const accountCardClassName =
  "overflow-hidden rounded-none border-0 p-0 lg:rounded-lg lg:border lg:border-gray-200";

export const accountHeaderClassName = "border-b border-gray-200 px-4 py-5 lg:px-10";

export const accountBodyClassName = "flex flex-col gap-6 px-4 py-8 lg:px-10";
